import './list-travel-voucher.scss';

import { GetTravelVoucherModel } from "@factory/model/query-model-travel-voucher";
import { useQyGetTravelVoucher } from "@factory/query/travel-voucher.query";
import { TableSort } from "@shared/models/table-sort";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from '@shared/ui/header-content/header-content';
import SearchInput from "@shared/ui/search-input/search-input";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { DataTable, DataTableStateEvent } from 'primereact/datatable';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { Sidebar } from "primereact/sidebar";
import { useState } from "react";
import { CiSearch } from "react-icons/ci";
import { MdClear } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { currencyFormat } from '../../../shared/utility/formats/currency-format';
import { FilterTravelVoucher } from "../filter-travel-voucher/filter-travel-voucher";
import { useFilterTravelVoucherContext } from "../filter-travel-voucher/filter-travel-voucher.context";

export function ListTravelVoucher() {
  // THIS IS THE LOCAL DECLARATION
  const navigate = useNavigate();
  const [rowLimit, setRowLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [first, setFirst] = useState(0);    
  const [tableSort, setTableSort] = useState<TableSort>({
    sortField: undefined,
    sortOrder: undefined,
  });  
  const [sort, setSort] = useState({});
  const [filterPanel, setFilterPanel] = useState(false);
  const { filterChipsElement, getFilterEntityValues } = useFilterTravelVoucherContext();

  // THIS IS THE QUERY DECLARATION
  const {
    data: travelVoucherResponse,
    isLoading,
    isError,
    error,
  } = useQyGetTravelVoucher(
    searchTerm,
    rowLimit,
    pageNumber,
    sort,
    getFilterEntityValues()
  );

  // THIS IS THE LOCAL DECLARATION
  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };
  const handleTableSort = (e: DataTableStateEvent) => {
    setTableSort({
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
    const order = e.sortOrder === 1 ? "ASC" : "DESC";
    setSort({ [e.sortField]: order });
  };
  const navigateToRecord = (item: GetTravelVoucherModel) => {
    navigate(`${item.code}`);
  };
  const onPageChange = (event: PaginatorPageChangeEvent) => {
    const offsetValue = event.page * rowLimit;
    setFirst(event.first);
    setPageNumber(offsetValue);
    setRowLimit(event.rows);
  };
  const handleNew = () => {
    navigate(`new`);
  };

  // THIS IS THE LOCAL RENDERS
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection title="Error Occured" message={(error as any)?.message} />
    </div>
  );
  const filterElement = (
    <section>
      <div className="flex gap-4 items-center mb-2">
        <SearchInput
          clearIcon={<MdClear />}
          searchIcon={<CiSearch />}
          searchTerm={searchTerm}
          onSearch={handleSearch}
          placeholder="Search items"
          className="w-full block"
        />
        <Button
          label="Filter"
          severity="secondary"
          badgeClassName="p-badge-danger"
          onClick={() => setFilterPanel(true)}
          outlined
        />
      </div>

      {filterChipsElement}
      <Sidebar visible={filterPanel} onHide={() => setFilterPanel(false)}>
        <FilterTravelVoucher />
      </Sidebar>
    </section>
  );
  const grid = (
    <section className="mt-6">
      <h5 className="mb-2">
        Total: <b>{ travelVoucherResponse?.count }</b>
      </h5>

      <DataTable
        value={ travelVoucherResponse?.data }
        selectionMode="single"
        onSelectionChange={(e) => navigateToRecord(e.value)}
        onSort={handleTableSort}
        sortField={tableSort.sortField}
        sortOrder={tableSort.sortOrder}
      >
        <Column field="client_name" header="Client Name" sortable></Column>
        <Column field="confirmation_num" header="Confirmation Num" sortable></Column>
        {/* <Column field="payment_completion" header="Payment Completion" sortable></Column> */}
        <Column field="is_fully_paid" header="Is Fully Paid" sortable
          body={(item) => (
            <Checkbox
              checked={item.amount_paid >= item.amount ? true : false}
              disabled
              inputId={``}
              className="p-checkbox-sm"
            />
          )}
        ></Column>
        <Column field="amount_paid" header="Amount Paid" sortable
        body={
          (item) => (
            <p>{currencyFormat(item.amount_paid)}</p>
          )
        } 
        ></Column>
        <Column field="amount" header="Amount" sortable
        body={
          (item) => (
            <p>{currencyFormat(item.amount)}</p>
          )
        } 
        ></Column>
      </DataTable>

      <Paginator
        first={first}
        rows={rowLimit}
        totalRecords={ travelVoucherResponse?.count}
        rowsPerPageOptions={[10, 20, 30]}
        onPageChange={onPageChange}
      />
    </section>
  );

  return (
    <div id="ListTravelVoucher" className="travel-voucher">
      <HeaderContent title={<h1>Travel Voucher</h1>}>
        <span className="flex gap-2">
          <Button label="New" onClick={handleNew} />
        </span>
      </HeaderContent>

       <div className="p-7">
        {filterElement}
        {isLoading && displayLoading}
        {isError && !isLoading && displayError}
        {!isLoading && !isError && grid}
      </div>
    </div>
  );
}

export default ListTravelVoucher;